










import { Vue, Component } from 'vue-property-decorator';
import MantenedorLocalidadBase from './MantenedorLocalidadBase.vue';

@Component({ components: { MantenedorLocalidadBase } })
export default class MantenedorLocalidadPantalla extends Vue {}
